<template>
    <span class="btn-elec-agree">
        
        
        <template v-if="listType==='zfcg'">
            <el-button
            type="text"
            v-if="(row.shbj==='1'||row.shbj==='9') && izShow"
            icon="el-icon-monitor"
            @click="dialogShow('1')">电子协议
            </el-button>
            
            <el-button
            type="text"
            v-if="(row.shbj==='1'||row.shbj==='9') && izShow"
            icon="el-icon-monitor"
            @click="dialogShow('3')">委托合同
            </el-button>

            <el-button
            type="text"
            v-if="(row.shbj==='1'||row.shbj==='9')&&(row.jyzxcode!==null&&row.jyzxcode.indexOf('J1304')>-1)"
            icon="el-icon-edit-outline"
            @click="dialogShow('2')">签署承诺书
            </el-button>
        </template>

        <template v-if="listType==='jsgcxm'">
            <el-button
            type="text"
            v-if="row.shbj==='1'"
            icon="el-icon-monitor"
            @click="dialogShow('1')">电子协议
            </el-button>

           
        </template>
        

        <template v-if="listType==='jsgc'">
            <el-button
            type="text"
            v-if="(row.shbj==='1'||row.shbj==='9')&&row.ext5.indexOf('1304')>-1"
            icon="el-icon-edit-outline"
            @click="dialogShow('2')">签署承诺书
            </el-button>
        </template>

        <my-dialog
        v-model="dialogVisible"
        :title="dialogTitle"
        width="80%">
            <form-elec-agree
            v-if="dialogVisible"
            :type="type"
            :row="row"
            @cancle="dialogClose">
            </form-elec-agree>
        </my-dialog>
    </span>
</template>

<script>
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

import FormElecAgree from '../form'

export default {
    mixins: [DIALOG_LIST_PAGE_MIXIN],
    components: {FormElecAgree},
    props: {
        row: {
            type: Object,
            default: () => ({})
        },
        listType:{
            type:String,
            default:''
        },
        izShow:{
            type:Boolean,
            default:true
        }
    },
    data () {
        return {
            dialogVisible:false,
            type:'',
            dialogTitle:''
        }
    },
    methods: {
        dialogShow(val){
            this.type = val
            this.dialogVisible = true
            if(val==='1'){
                this.dialogTitle = '电子协议'
            }else if(val==='2'){
                this.dialogTitle = '承诺书'
            }else if(val==='3'){
                this.dialogTitle = '委托合同'
            }
        },

    },
    mounted: function() {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-button + .btn-elec-agree{margin-left:10px;}
/deep/ .btn-content{ margin-bottom: 10px;}
/deep/ .el-dialog__body{ padding-top: 0; }
</style>
